<!-- Status chip -->
<div
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = true"
  cdkOverlayOrigin
  class="filter-button status-filter flex flex-row gap-[20px]"
  data-testid="diary-status-filter-btn"
  type="button"
>
  <div class="label text-type-8">{{ buttonLabel }}</div>
  <mat-icon class="filter-icon" svgIcon="filters" />
</div>

<ng-template
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  cdkConnectedOverlay
>
  <div class="daily-diary-status-filter-popup">
    <div class="filter-tabs" role="tablist">
      <button class="filter-tab active" type="button">Status</button>
    </div>
    <div class="filter-tab-content">
      <app-checkbox-list-with-filter
        (selectionChange)="onStatusCheckboxChange($event)"
        [displaySearch]="false"
        [displaySelectAll]="true"
        [options]="statusOptions"
        [parentFormGroup]="searchForm"
        controlName="statusSearch"
      />
    </div>
  </div>
</ng-template>

<!-- Date range chip -->
<div
  class="filter-button datepicker flex flex-row"
  data-testid="diary-date-filter-chip"
>
  <div (click)="picker.open()" data-testid="diary-date-filter-btn">
    <div class="flex flex-row gap-[10px]">
      <div class="label text-type-8" data-testid="diary-date-filter-label">{{ dateLabel }}</div>
      <mat-icon class="filter-icon" svgIcon="calendar" />
    </div>
  </div>
  @if (showClearDate) {
    <mat-icon
      (click)="resetDateFilter($event)"
      class="filter-icon close-icon"
      matTooltip="Remove date filter"
      >close
    </mat-icon>
  }

  <form [formGroup]="form" class="h-0">
    <mat-form-field class="date-picker">
      <mat-date-range-input [rangePicker]="picker">
        <input formControlName="startDate" matStartDate />
        <input formControlName="endDate" matEndDate />
      </mat-date-range-input>
      <!-- No actions row: the daily report's date chip uses a plain range
           picker that applies as soon as the range is complete. "All Time" is
           the chip's X (remove the filter), so there is nothing an Apply /
           Cancel / All Time row would add. -->
      <mat-date-range-picker
        #picker
        [calendarHeaderComponent]="calendarHeader"
        panelClass="filter-datepicker-panel"
      ></mat-date-range-picker>
    </mat-form-field>
  </form>
</div>
